const currentUserConstants = {
  CHANGE_USER: "CHANGE_USER",
  GET_USER_SUCCESS: "GET_USER_SUCCESS",
  GET_USER_FAIL: "GET_USER_FAIL",
  GET_PERMISSIONS_SUCCESS: "GET_PERMISSIONS_SUCCESS",
  GET_PERMISSIONS_FAIL: "GET_PERMISSIONS_FAIL",
};

export default currentUserConstants;
